module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/872031593c5ab3d019cd4df008f49816.png";